import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { amber } from "../characters/Amber";
import { cashier } from "../characters/Cashier";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mario } from "../characters/Mario";
import { mc } from "../characters/MC";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V6EmilyShoppingAfter } from "./V6";

export const V6EmilyShopping = async (): Promise<any> => {
    doTransition(images.v6.EmilyShopping_0);
    emily.talk(`I'm so happy you decided to join me!`);
    await cashier.set((properties) => {
        cashier.name = "Saleswoman";
    });
    mc.talk(`You made it easy for me when you offered your car.`);
    emily.talk(`Still! It's been so long since we have seen each other. It's nice... I like hanging out with you...`);
    mc.talk(`I missed you too Emily.`);
    mc.talk(`You still haven't told me where we are going.`);
    emily.talk(`There is a new shop I found online while I was browsing for.... clothing stores and it seems really nice and has good prices.`);
    mc.talk(`Is it close?`);
    ImageClass.setImage(images.v6.EmilyShopping_1);
    emily.talk(`Actually it's right here!`);
    mc.talk(`Oh... I don't know this one.`);
    mc.talk(`But I never pay attention to these types of stores, so I couldn't tell how long it's been here.`);
    emily.talk(`They are relatively new! Opened a couple of months from what I read. That's why everything is cheap; they want to make a name for themselves.`);
    mc.talk(`So what are you looking for?`);
    emily.talk(`I need a dress that would be both cute and sexy at the same time.`);
    mc.talk(`What for? Is there somebody new?`);
    emily.talk(`Nooo... You know me, I like new stuff.`);

    ImageClass.setImage(images.v6.EmilyShopping_2);
    emily.talk(`They have nice things out on display.`);

    if (mc.properties.v6EmilyPhotosSeen.length > 0) {
        mc.think(`She is lying... First the pics, now the dress... There is something she is not telling me.`);
    }

    emily.talk(`But I don't see the discount they published on the site...`);
    mc.talk(`We can ask the saleswoman.`);
    ImageClass.setImage(images.v6.EmilyShopping_3);
    mc.talk(`Sure, let's ask her.`);
    ImageClass.setImage(images.v6.EmilyShopping_4, { transition: true });
    emily.talk(`Hello...`);
    cashier.think(`*Click click click click*`);
    emily.talk(`I saw on your site that you have some clothes on sale.`);
    cashier.think(`*Click click click click*`);
    if (Game.seenScenarios.includes(`V5AnnMovieStandingInLine`)) {

        mc.think(`I remember this bitch, she was the cashier when I went with Ann to try and get tickets to that movie she wanted to see.`);
    }
    ImageClass.setImage(images.v6.EmilyShopping_5);
    emily.talk(`Hellooo!!`);
    ImageClass.setImage(images.v6.EmilyShopping_6);
    cashier.talk(`Can't you see that I'm busy?`);
    ImageClass.setImage(images.v6.EmilyShopping_5);
    return jump(V6EmilyShopping_Question, "V6EmilyShopping_Question");
};

export const V6EmilyShopping_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_5);
    await cashier.setQuestion(new Question({ text: `*Click click click click*`, options: { think: true }, key: `v6EmilyShoppingAngryAtCashier` })
        .option({ title: `Get angry at the saleswoman`, key: true })
        .option({ title: `Let Emily talk to her`, key: false }));


    if (Question.globalAnswers.v6EmilyShoppingAngryAtCashier) {

        return jump(V6EmilyShopping_Question_Angry, "V6EmilyShopping_Question_Angry");
    } else {

        return jump(V6EmilyShopping_Question_LetEmily, "V6EmilyShopping_Question_LetEmily");
    }
};

export const V6EmilyShopping_Question_Angry = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_5);
    await mc.set((properties) => {
        properties.emilyRelationship++;
        properties.alpha++;
    });
    mc.talk(`Hey! Put the fucking phone down and answer her question!`);
    ImageClass.setImage(images.v6.EmilyShopping_7_2);
    cashier.talk(`What do you need?`);
    if (Game.seenScenarios.includes(`V5AnnMovieStandingInLine`)) {
        mc.talk(`I remember you by the way.`);
        mc.talk(`My girlfriend tried to get tickets for a movie from you yesterday.`);
        cashier.talk(`We were sold out.`);
        mc.talk(`I can't believe two people hired you.`);
        ImageClass.setImage(images.v6.EmilyShopping_5);
        cashier.think(`*Click click click click*`);
        mc.talk(`Yo! Get your head out of your ass and tell us which clothes are on sale.`);
    } else {
        mc.talk(`The lady asked you which clothes are on sale.`);
        cashier.talk(`The ones with the discount tags on them.`);
        ImageClass.setImage(images.v6.EmilyShopping_4);
        cashier.think(`*Click click click click*`);
        mc.talk(`Are you stupid or something? None of the clothes we saw had discount tags on them!`);
    }
    ImageClass.setImage(images.v6.EmilyShopping_8);
    cashier.talk(`The clothes that are on sale are showcased in the display window.`);
    return jump(V6EmilyShopping_2, "V6EmilyShopping_2");
};

export const V6EmilyShopping_Question_LetEmily = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_5);
    emily.talk(`Busy with what? I need service.`);
    ImageClass.setImage(images.v6.EmilyShopping_6);
    cashier.talk(`Still here? Give me a second.`);
    ImageClass.setImage(images.v6.EmilyShopping_4);
    cashier.think(`*Click Click...*`);
    cashier.think(`*Click Click Click...*`);
    cashier.think(`*Click Click Click Click...*`);
    emily.talk(`Is it gonna take long?`);
    cashier.think(`*Click Click...*`);
    cashier.talk(`Hold on I'm about to beat my high score!`);
    ImageClass.setImage(images.v6.EmilyShopping_4);
    cashier.think(`*Click Click...*`);
    cashier.talk(`FUCK!`);
    ImageClass.setImage(images.v6.EmilyShopping_6_2);
    cashier.talk(`What do you need?`);
    emily.talk(`Again... Which clothes are on sale?`);
    ImageClass.setImage(images.v6.EmilyShopping_8);
    cashier.talk(`The clothes on sale are showcased in the display window.`);
    emily.talk(`That wasn't so hard, was it?`);
    ImageClass.setImage(images.v6.EmilyShopping_4);
    cashier.think(`*Click Click...*`);
    emily.talk(`What the...?!`);

    return jump(V6EmilyShopping_2, "V6EmilyShopping_2");
};

export const V6EmilyShopping_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_9, { transition: true });
    emily.talk(`What the fuck was that service?`);
    emily.talk(`So rude...`);
    if (Game.seenScenarios.includes(`V5AnnMovieStandingInLine`) && !Game.seenScenarios.includes(`V6EmilyShopping_Question_Angry`)) {
        mc.talk(`I've seen her before.`);
        emily.talk(`You did? When?`);
        mc.talk(`When I went with Ann to the movies.`);
        mc.talk(`She is a total bitch.`);
        emily.talk(`I know!`);
        emily.talk(`I'm usually a patient person but I was one step away from shoving my heel up her ass.`);
    }
    if (!Game.seenScenarios.includes(`V5AnnMovieStandingInLine`)) {

        mc.talk(`Yeah, like who the fuck hired her.`);
    } else {

    }
    if (Game.seenScenarios.includes(`V6EmilyShopping_Question_Angry`)) {

        emily.talk(`Thanks for having my back.`);
    } else {

    }



    mc.talk(`Just forget about her, don't let her ruin your mood.`);
    emily.talk(`You are right.`);
    emily.talk(`Well, I guess I don't have many options, there were only two dresses on display.`);
    emily.talk(`Which one do you think is the best for me?`);
    mc.talk(`I didn't really pay attention to them. I need to go and have another look.`);
    mc.talk(`By the way, what are they for?`);
    emily.talk(`I already told you! Something that will be both cute and sexy.`);
    mc.talk(`Sure, be right back.`);
    emily.talk(`I really hope at least one of them will look good on me.`);

    return jump(V6EmilyShopping_2_CheckingClothes, "V6EmilyShopping_2_CheckingClothes");
};

export const V6EmilyShopping_2_CheckingClothes = async (): Promise<any> => {
    let seen = false;

    if (mc.properties.v6EmilyShoppingDress === "black") {

        ImageClass.setImage(images.v6.EmilyShopping_11, { transition: true });
    } else {
        ImageClass.setImage(images.v6.EmilyShopping_10, { transition: true });

    }

    if (!Game.seenScenarios.includes(`V6EmilyShopping_2_CheckingClothes`)) {
        mc.think(`I know she told me to look at the dresses, but I can't ignore the lingerie... It's like the ones she was browsing.`);

    }

    await mc.setQuestion(new Question({ text: `Let's see what they have in store.`, options: { think: true }, key: `v6EmilyShoppingWindowSwitch` })
        .option({ title: `Pick this dress`, key: false })
        .option({ title: `Check the other dress`, key: true }));


    if (Question.globalAnswers.v6EmilyShoppingWindowSwitch) {
        if (mc.properties.v6EmilyShoppingDress === "black") {
            await mc.set((properties) => {
                properties.v6EmilyShoppingDress = "purple";
            });
        } else {
            await mc.set((properties) => {
                properties.v6EmilyShoppingDress = "black";
            });

        }
    } else {

        return jump(V6EmilyShopping_2_CheckingClothes_This, "V6EmilyShopping_2_CheckingClothes_This");


    }
    return jump(V6EmilyShopping_2_CheckingClothes, "V6EmilyShopping_2_CheckingClothes");

};

export const V6EmilyShopping_2_CheckingClothes_This = async (): Promise<any> => {
    if (mc.properties.v6EmilyShoppingDress === "purple") {

        ImageClass.setImage(images.v6.EmilyShopping_10);
        mc.think(`A purple dress that doesn't show much but can still be sexy on some girls...`);
        mc.think(`I like it, let's see what she has to say.`);
    } else {

        ImageClass.setImage(images.v6.EmilyShopping_11);
        mc.think(`A black mini-dress with a huge cleavage... Why not?`);
        mc.think(`Emily said both sexy and cute, but this one is full-on sexy.`);
    }

    mc.think(`I like it, let's see what she has to say.`);


    return jump(V6EmilyShopping_3, "V6EmilyShopping_3");
};

export const V6EmilyShopping_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_12, { transition: true });

    if (mc.properties.v6EmilyShoppingDress === "purple") {
        mc.talk(`Emily, I prefer the purple dress.`);
        emily.talk(`I like it, but I think it's missing something, I just can't pinpoint what.`);
        emily.talk(`But it may look good on me.`);
    } else {
        mc.talk(`Emily, I prefer the black dress.`);
        emily.talk(`Really? The black one? I like it but... Isn't it too much?`);
    }
    emily.talk(`I guess there is only one way to find out.`);
    emily.talk(`I'm gonna try it on.`);

    return jump(V6EmilyShopping_4, "V6EmilyShopping_4");
};

export const V6EmilyShopping_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_13, { transition: true });
    emily.talk(`There aren't locks on the door. Watch it for me!`);
    mc.talk(`I'll be here.`);
    ImageClass.setImage(images.v6.EmilyShopping_23);
    await mc.think(`Now to the boring part... Waiting for Emily to make up her mind...`);
    await mario.set((properties) => {
        mario.name = "Boyfriend";
    });
    await amber.set((properties) => {
        amber.name = "Girlfriend";
    });
    mario.talk(`Come on! Pick something already!`);
    mc.think(`Huh?`);
    ImageClass.setImage(images.v6.EmilyShopping_14, { transition: true });
    mario.talk(`We've been here for almost two hours! Pick something and let's go!`);
    amber.talk(`Honey! I'm trying to find something special just for you.`);
    mario.talk(`I know, but fucking hell... I'll pay for anything just take something... Anything!`);
    mc.think(`I wonder how long they've been here.`);
    mc.think(`Now I remember why I always refused going shopping with Emily.`);
    amber.talk(`Fine!`);
    ImageClass.setImage(images.v6.EmilyShopping_15);
    amber.talk(`Just make sure no one will get in while I'm changing.`);
    mario.talk(`FINE! Just make it quick!`);
    ImageClass.setImage(images.v6.EmilyShopping_23, { transition: true });
    mc.think(`Was I imagining or did she just give me a flirty look on her way to her booth?`);
    mario.talk(`PST.`);

    return jump(EmilyShopping_5, "EmilyShopping_5");
};

export const EmilyShopping_5 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_24);
    mario.talk(`I see we are on the same boat.`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`Yeah I guess.`);

    ImageClass.setImage(images.v6.EmilyShopping_24);
    mario.talk(`Girls can drive you crazy.`);
    mario.talk(`I always keep saying to myself that it will be the last time I'm going shopping with her.`);
    mario.talk(`But you know what it's like... she suddenly starts with her sweet talk, whispering in my ear... No one can resist it.`);

    mc.talk(`Well, it's different in my case, she is my ${emily.properties.relation.toLocaleLowerCase()}.`);
    mario.talk(`Oh shit. So why are you here?`);
    mc.talk(`She managed to convince me.`);
    // <action type="vmod" name="temp.tn1" do="set" value="0"/>

    return jump(V6AfterEmilyShoppingTryingDress, "V6AfterEmilyShoppingTryingDress");
};

export const V6AfterEmilyShoppingTryingDress = async (): Promise<any> => {

    if (mc.properties.v6EmilyShoppingDress === "purple") {

        doTransition(images.v6.EmilyShopping_17, null, 0.5);
    } else {

        doTransition(images.v6.EmilyShopping_18, null, 0.5);
    }

    if (!Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDress`)) {

        emily.talk(`I hope it didn't take me too long.`);
    } else {

    }

    // Emily is showing the dress for the first time
    if ((!Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDress`) && empty.properties.v6EmilyClothingStoreTimesChanged === 0) || (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDress`) && empty.properties.v6EmilyClothingStoreTimesChanged === 1)) {
        if (mc.properties.v6EmilyShoppingDress === "purple") {
            return jump(V6AfterEmilyShoppingTryingDressPurple, "V6AfterEmilyShoppingTryingDressPurple");

        } else {
            mc.think(`Holy shit...`);
            mc.think(`That's one revealing dress.`);
            mc.talk(`I can't say it doesn't look good.`);
            emily.talk(`I agree, even though my boobs are almost out.`);
            return jump(V6AfterEmilyShoppingTryingDressBlack, "V6AfterEmilyShoppingTryingDressBlack");
        }

    }

    if (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDress`) && empty.properties.v6EmilyClothingStoreTimesChanged > 1) {

        emily.talk(`Ok... Here it is again.`);
    } else {

    }


    return jump(V6AfterEmilyShoppingTryingDress_Question, "V6AfterEmilyShoppingTryingDress_Question");
};

export const V6AfterEmilyShoppingTryingDressBlack = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_18);
    await emily.setQuestion(new Question({ text: `I agree, even though my boobs are almost out.`, options: { think: false }, key: `v6EmilyShoppingMcLikedBlackDress` })
        .option({ title: `It looks great`, key: true })
        .option({ title: `It's too much`, key: false }));


    if (Question.globalAnswers.v6EmilyShoppingMcLikedBlackDress) {
        if (!Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDressPurple`)) {
            await mc.set((properties) => {
                properties.emilyRelationship++;
            });
        }
        mc.talk(`It looks great.`);
        emily.talk(`Great!`);
    } else {
        mc.talk(`It's too much.`);
        emily.talk(`Oh...`);
    }


    return jump(V6AfterEmilyShoppingTryingDressBlack_Question, "V6AfterEmilyShoppingTryingDressBlack_Question");




};
export const V6AfterEmilyShoppingTryingDressBlack_Question = async (): Promise<any> => {

    ImageClass.setImage(images.v6.EmilyShopping_20);
    emily.talk(`I just hope it looks good even from behind...`);
    emily.talk(`Even if it doesn't I'll deal with it!`);
    emily.talk(`So... What do you say?`);
    return jump(V6AfterEmilyShoppingTryingDress_Question, "V6AfterEmilyShoppingTryingDress_Question");
};

export const V6AfterEmilyShoppingTryingDressPurple = async (): Promise<any> => {
    emily.talk(`What do you think?`);
    mc.talk(`I can't say it doesn't look good.`);
    await emily.setQuestion(new Question({ text: `It's cute alright... But does it look good on me?`, options: { think: false }, key: `v6EmilyShoppingMcLikedPurpleDress` })
        .option({ title: `It looks amazing on you`, key: true })
        .option({ title: `I think you can do better`, key: false }));


    if (Question.globalAnswers.v6EmilyShoppingMcLikedPurpleDress) {
        if (!Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDressBlack`)) {
            await mc.set((properties) => {
                properties.emilyRelationship++;
            });
        }

        mc.talk(`It looks amazing on you.`);

    } else {
        mc.talk(`I think you can do better.`);
        emily.talk(`Oh...`);
        emily.talk(`And let's say I'm gonna take it.`);
    }


    return jump(V6AfterEmilyShoppingTryingDressPurple_Question, "V6AfterEmilyShoppingTryingDressPurple_Question");
};

export const V6AfterEmilyShoppingTryingDressPurple_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_19);
    emily.talk(`I just hope it looks good even from behind...`);
    emily.talk(`Even if it doesn't I'll deal with it!`);
    emily.talk(`So... What do you say?`);

    return jump(V6AfterEmilyShoppingTryingDress_Question, "V6AfterEmilyShoppingTryingDress_Question");
};
export const V6AfterEmilyShoppingTryingDress_Question = async (): Promise<any> => {
    if (mc.properties.v6EmilyShoppingDress === "purple") {

        ImageClass.setImage(images.v6.EmilyShopping_22);
    } else {
        ImageClass.setImage(images.v6.EmilyShopping_21);
    }

    await emily.setQuestion(new Question({ text: `Should I take it?`, options: { think: false }, key: `v6EmilyShoppingShouldTakeDress` })
        .option({ title: `Yes`, key: true })
        .option({ title: `Try the other one`, key: false }));


    if (Question.globalAnswers.v6EmilyShoppingShouldTakeDress) {

        mc.talk(`Yes.`);
        if (mc.properties.v6EmilyShoppingDress === "purple") {
            if (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDressBlack_Question`)) {

                mc.talk(`The black one was too much.`);
            } else {
                mc.talk(`Sold! No need to try on the other one, this one is great.`);

            }

        } else {
            if (Game.seenScenarios.includes(`V6AfterEmilyShoppingTryingDressPurple_Question`)) {

                mc.talk(`The purple one was nice, but it wasn't enough.`);
            } else {
                mc.talk(`I don't even need to see the other one on you, this one is perfect.`);

            }

        }
        return jump(V6AfterEmilyShoppingTryingDress_Question_This, "V6AfterEmilyShoppingTryingDress_Question_This");
    } else {
        return jump(V6AfterEmilyShoppingTryingDress_Question_Another, "V6AfterEmilyShoppingTryingDress_Question_Another");

    }
};

export const V6AfterEmilyShoppingTryingDress_Question_Another = async (): Promise<any> => {
    // <action type="vmod" name="temp.tn1" do="add" value="1"/>
    await empty.set((properties) => {
        properties.v6EmilyClothingStoreTimesChanged++;
    });
    if (mc.properties.v6EmilyShoppingDress === "purple") {

        ImageClass.setImage(images.v6.EmilyShopping_22);
    } else {

        ImageClass.setImage(images.v6.EmilyShopping_21);
    }

    mc.talk(`I think you should try on the second dress.`);
    if (empty.properties.v6EmilyClothingStoreTimesChanged === 1) {

        emily.talk(`Alright! Give me a minute!`);
    } else if (empty.properties.v6EmilyClothingStoreTimesChanged === 2) {
        emily.talk(`Really? Again?`);
        mc.talk(`Yes, I didn't have a good look.`);
        emily.talk(`Alright! Give me a minute!`);
    } else if (empty.properties.v6EmilyClothingStoreTimesChanged === 3) {
        emily.talk(`Are you serious? How many times do you want me to keep changing?`);
        mc.talk(`I'm trying to help you!`);
        emily.talk(`Ok... Just a second.`);
    } else if (empty.properties.v6EmilyClothingStoreTimesChanged === 4) {
        emily.talk(`I feel like you are trying to drive me crazy...`);
        mc.talk(`Nah, I just haven't made my mind yet.`);
        emily.talk(`Ok...`);
    } else if (empty.properties.v6EmilyClothingStoreTimesChanged === 5) {
        emily.talk(`${mc.name}!`);
        mc.talk(`I'm almost sure...`);
        emily.talk(`Fine.`);
    } else if (empty.properties.v6EmilyClothingStoreTimesChanged >= 6) {

        emily.talk(`I don't care anymore I've got all day!`);
    }




    if (empty.properties.v6EmilyClothingStoreTimesChanged === 1) {
        ImageClass.setImage(images.v6.EmilyShopping_24);
        mario.talk(`Damn bro, your ${emily.properties.relation.toLocaleLowerCase()}, is hot as fuck.`);
        ImageClass.setImage(images.v6.EmilyShopping_16);
        mc.talk(`Thanks...?`);
        mc.think(`His girlfriend is right in that booth but he doesn't seem to give a fuck.`);

    }

    // Emily is showing the second dress for the first time - Mario second reaction
    if (empty.properties.v6EmilyClothingStoreTimesChanged === 2) {
        ImageClass.setImage(images.v6.EmilyShopping_24);
        if (mc.properties.v6EmilyShoppingDress === "purple") {
            mario.talk(`What the fuck is that dress bro? Tell her to take the black dress, WAY better.`);

            ImageClass.setImage(images.v6.EmilyShopping_16);
            mc.talk(`Thanks for the advice.`);
        } else {
            mario.talk(`That's a winner right there, tell her to take it. The other one doesn't do justice to her body.`);
        }
    }







    if (mc.properties.v6EmilyShoppingDress === "purple") {
        await mc.set((properties) => {
            properties.v6EmilyShoppingDress = "black";
        });

    } else {
        await mc.set((properties) => {
            properties.v6EmilyShoppingDress = "purple";
        });
    }
    return jump(V6AfterEmilyShoppingTryingDress, "V6AfterEmilyShoppingTryingDress");
};

export const V6AfterEmilyShoppingTryingDress_Question_This = async (): Promise<any> => {

    if (mc.properties.v6EmilyShoppingDress === "purple") {
        ImageClass.setImage(images.v6.EmilyShopping_22);
        await emily.set((properties) => {
            properties.v6PickedDress = "purple";
        });
    } else {
        ImageClass.setImage(images.v6.EmilyShopping_21);
        await emily.set((properties) => {
            properties.v6PickedDress = "black";
        });
    }

    emily.talk(`Ok! I trust your taste!`);
    mc.talk(`So, are we ready to go?`);
    emily.talk(`Not just yet, I want to try another thing.`);
    emily.talk(`Do you mind waiting a bit more?`);
    mc.talk(`I don't think I have much of a choice.`);
    emily.talk(`I'll do it fast! I promise!`);
    ImageClass.setImage(images.v6.EmilyShopping_23);
    mc.think(`She already picked the dress, what else does she need to try on?`);
    mc.think(`Did she take the lingerie inside when I wasn't looking?`);
    return jump(V6AfterEmilyShoppingTryingLingerieMario, "V6AfterEmilyShoppingTryingLingerieMario");
};

export const V6AfterEmilyShoppingTryingLingerieMario = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_23);
    await mario.talk(`Yo bro.`);
    ImageClass.setImage(images.v6.EmilyShopping_24);
    await mario.set((properties) => {
        mario.name = "Mario";
    });
    mario.talk(`I'm Mario, by the way.`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`${mc.name}.`);
    ImageClass.setImage(images.v6.EmilyShopping_24);
    mario.talk(`You are lucky she agreed to go with the dress you picked.`);
    mario.talk(`My girl never agrees with me.`);
    mario.talk(`I can spend hours in here.`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`Well, I'm still here, she just went to try something else...`);
    ImageClass.setImage(images.v6.EmilyShopping_24);

    mario.talk(`What is she trying on?`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`I don't know, she didn't say.`);
    ImageClass.setImage(images.v6.EmilyShopping_24);
    mario.talk(`Aren't you curious?`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`I have an idea, but I won't lose sleep over it...`);

    return jump(V6AfterEmilyShoppingTryingLingerieMario_Question, "V6AfterEmilyShoppingTryingLingerieMario_Question");
};

export const V6AfterEmilyShoppingTryingLingerieMario_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_24);

    let text = "Aren't you curious?";
    if (Question.globalAnswers.v1EnableNTR) {

        text = "You should let me take a peek so I could confirm it.";
    } else {

    }
    // TODO: add an option to peep on Amber without NTR enabled
    await mario.setQuestion(new Question({ text, options: { think: false }, key: `v6EmilyShoppingLetMarioWantsToPeep` })
        .option({ title: `Fine, go ahead`, key: "goAhead", show: Question.globalAnswers.v1EnableNTR })
        .option({ title: `${Question.globalAnswers.v1EnableNTR ? "I'll check myself" : "Alright, I'll check"}`, key: "IllCheckMyself" })
        .option({ title: `Nah, I'm good`, key: "Imgood" }));


    if (Question.globalAnswers.v6EmilyShoppingLetMarioWantsToPeep === "goAhead") {
        return jump(V6AfterEmilyShoppingTryingLingerieMario_Question_LetHim, "V6AfterEmilyShoppingTryingLingerieMario_Question_LetHim");

    } else if (Question.globalAnswers.v6EmilyShoppingLetMarioWantsToPeep === "IllCheckMyself") {
        return jump(V6AfterEmilyShoppingTryingLingerieMario_Question_CheckYourself, "V6AfterEmilyShoppingTryingLingerieMario_Question_CheckYourself");

    } else {
        return jump(V6AfterEmilyShoppingTryingLingerieMario_Question_ImGood, "V6AfterEmilyShoppingTryingLingerieMario_Question_ImGood");

    }
};

export const V6AfterEmilyShoppingTryingLingerieMario_Question_LetHim = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_24);

    mc.talk(`Fine, go ahead.`);
    mario.talk(`It's for a good cause.`);
    mario.talk(`Step aside.`);
    ImageClass.setImage(images.v6.EmilyShopping_27);
    mc.think(`That was a lame excuse to peep after Emily, I know he's been dying to creep on her since we got here... But who cares?`);
    ImageClass.setImage(images.v6.EmilyShopping_33);

    mario.talk(`Bruh.`, { method: "Whispering" });
    mc.talk(`What is it?`, { method: "Whispering" });
    mario.talk(`You have no idea.`, { method: "Whispering" });
    mario.talk(`I knew that she is hot, but I didn't realize how much.`, { method: "Whispering" });
    mario.talk(`I don't know who she is buying it for, but he is one lucky guy.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.EmilyShopping_27);
    mc.think(`I have no idea what he is looking at but he is obviously enjoying himself...`);

    return jump(V6AfterEmilyShoppingTryingLingerieAmber_Question, "V6AfterEmilyShoppingTryingLingerieAmber_Question");

};

export const V6AfterEmilyShoppingTryingLingerieAmber_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_27);
    await mc.setQuestion(new Question({ text: `I don't think he cares about his girl at this point... I can try and make some excuse to peep on her as well.`, options: { think: true }, key: `v6EmilyShoppingMadeExcuseToPeepAmber` })
        .option({ title: `Make an excuse`, key: true })
        .option({ title: `Do nothing`, key: false }));


    if (Question.globalAnswers.v6EmilyShoppingMadeExcuseToPeepAmber) {
        return jump(V6AfterEmilyShoppingTryingLingerieAmber_Question_Excuse, "V6AfterEmilyShoppingTryingLingerieAmber_Question_Excuse");

    } else {
        return jump(V6AfterEmilyShoppingTryingLingerieAmber_Question_DoNothing, "V6AfterEmilyShoppingTryingLingerieAmber_Question_DoNothing");

    }
};

export const V6AfterEmilyShoppingTryingLingerieAmber_Question_Excuse = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_27);
    mc.talk(`Hey Mario.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.EmilyShopping_33);
    mario.talk(`Yes?`, { method: "Whispering" });
    mc.talk(`Your girl has been inside there for too long, aren't you worried?`, { method: "Whispering" });
    mario.talk(`I have better things to do right now, ha ha.`, { method: "Whispering" });
    mc.talk(`I can check up on her. You know, like you are checking on my ${emily.properties.relation.toLocaleLowerCase()}.`, { method: "Whispering" });
    mario.talk(`Bro, I'm busy, do whatever you want I don't care.`, { method: "Whispering" });
    mc.think(`I don't think he fully listened to me but who cares?`);
    doWaitImageByTime(images.v6.EmilyShopping_28);
    mc.think(`Let's see what's behind door number two.`);
    ImageClass.setImage(images.v6.EmilyShopping_29);
    mc.think(`Nice ASS!`);
    mc.think(`It paid off coming here with Emily.`);
    mc.think(`That's not an outfit you can go out with.`);
    mc.think(`So I guess she is trying it out for Mario...\nIf she only knew what he is doing right now.`);
    ImageClass.setImage(images.v6.EmilyShopping_30);
    mc.think(`Shit, she noticed me.`);
    mc.think(`But... She is looking right at me... And smiling?`);

    doWaitImageByTime(images.v6.EmilyShopping_31);
    mc.think(`Oh...`);
    mc.think(`Now I'm sure that she doesn't care about me standing here.`);
    mario.talk(`Pst.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.EmilyShopping_32);
    mario.talk(`Enjoying the view?`, { method: "Whispering" });
    mc.think(`Well, this is awkward...`);
    mc.talk(`I am.`, { method: "Whispering" });
    mario.talk(`Cool, but I've seen enough. You are a real bro.`, { method: "Whispering" });


    return jump(V6EmilyShoppingReadyToLeave, "V6EmilyShoppingReadyToLeave");
};

export const V6AfterEmilyShoppingTryingLingerieAmber_Question_DoNothing = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_28);
    mc.talk(`Thanks, but I'm good.`, { method: "Whispering" });
    mario.talk(`Suit yourself bro.`, { method: "Whispering" });

    return jump(V6EmilyShoppingReadyToLeave, "V6EmilyShoppingReadyToLeave");
};

export const V6AfterEmilyShoppingTryingLingerieMario_Question_CheckYourself = async (): Promise<any> => {
    if (Question.globalAnswers.v1EnableNTR) {
        ImageClass.setImage(images.v6.EmilyShopping_24);
        mc.talk(`I'll check on her myself.`);

    } else {
        mc.talk(`Alright, I'll check`);
    }
    ImageClass.setImage(images.v6.EmilyShopping_23);
    mc.think(`Time to see what's behind door number one.`);
    ImageClass.setImage(images.v6.EmilyShopping_26, { duration: 0.6 });
    mc.think(`I knew she didn't come here just to buy some "cute" dresses.`);
    mc.think(`But holy shit... I didn't know Emily is buying these kind of outfits.`);
    ImageClass.setImage(images.v6.EmilyShopping_25, { duration: 0.6 });
    mc.think(`She really wants to make sure it looks good on her.`);
    mc.think(`But why? She'd told me she broke up with her boyfriend.`);
    mc.think(`Well, since we live in the same house she can't really hide stuff from me, so I guess I'll find out soon...`);
    mc.think(`I better close the door before she notices.`);
    ImageClass.setImage(images.v6.EmilyShopping_23);
    mario.talk(`WELL?`);
    ImageClass.setImage(images.v6.EmilyShopping_24);
    mc.talk(`I confirmed it alright.`);
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mario.talk(`Ha ha, I bet you liked it.`);


    return jump(V6EmilyShoppingReadyToLeave, "V6EmilyShoppingReadyToLeave");
};

export const V6AfterEmilyShoppingTryingLingerieMario_Question_ImGood = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_16);
    mc.talk(`Nah, I'm good.`);
    ImageClass.setImage(images.v6.EmilyShopping_24);
    mario.talk(`Ok, bro.`);
    ImageClass.setImage(images.v6.EmilyShopping_23);
    mc.think(`Now I just need to wait...`);

    return jump(V6EmilyShoppingReadyToLeave, "V6EmilyShoppingReadyToLeave");
};


export const V6EmilyShoppingReadyToLeave = async (): Promise<any> => {
    ImageClass.setImage(images.v6.EmilyShopping_13, { duration: 0.6, transition: true });
    emily.talk(`I'm ready to pay up and leave!`);
    mc.talk(`Great.`);

    ImageClass.setImage(images.v6.EmilyShopping_34, { transition: true });
    emily.talk(`Hey, can I pay for this?`);
    cashier.think(`*Click click click click*`);
    ImageClass.setImage(images.v6.EmilyShopping_35);
    cashier.talk(`The clothes that are on sale are showcased in the display window.`);
    emily.talk(`I know that, that's what I bought... Can I just pay up and leave?`);
    ImageClass.setImage(images.v6.EmilyShopping_34);
    cashier.think(`*Click click click click*`);
    ImageClass.setImage(images.v6.EmilyShopping_35);
    cashier.talk(`Sure.`);
    mc.think(`At least that was fast...`);

    return jump(V6EmilyShoppingAfter, "V6EmilyShoppingAfter");
};




